import { getTrainingData } from "./responsiveNavService"
import { UserInfo } from "./responsiveNavService"


export const fetchTraining = async () => {
    try {
        const data = await getTrainingData()


        if (data) {
            //console.log('data training: ', data)
            return { data }
        }
    } catch (error) {
        //console.log('error training: ', error)
    }
}

export const getUserInfo = async () => {

    const response = await UserInfo()

    if (response) {
        //console.log('response info sidemenu controller:', response)
    }
}   